const isItemDisabled = (menuItem, endpointAccess) => {
  return !!menuItem.serverName && !endpointAccess.some(({ ServerName }) => ServerName === menuItem.serverName);
};

const updateSubMenu = (submenu, endpointAccess) => {
  const updatedSubmenu = updateMenuWithApiAccess(submenu, endpointAccess);
  const isTreeDisabled = updatedSubmenu.every(submenuItem => submenuItem.disabled);
  return { submenu: updatedSubmenu, disabled: isTreeDisabled };
};

export const updateMenuWithApiAccess = (MainMenuConfig, endpointAccess) => {
  return MainMenuConfig.map(({ submenu, ...menuItem }) => {
    if (submenu) {
      return { ...menuItem, ...updateSubMenu(submenu, endpointAccess) };
    }
    return isItemDisabled(menuItem, endpointAccess) ? { ...menuItem, disabled: true } : menuItem;
  });
};